export const LEAD_STATUSES = [
  "Neuer Lead", "Daten unvollständig", "Rückfrage gesendet",
  "Angebotsentwurf erstellt", "Wartet auf Freigabe", "Angebot versendet",
  "Angebot geöffnet", "Nachfassen aktiv", "Kunde hat geantwortet",
  "Hot Lead", "Rückruf geplant", "Gewonnen", "Verloren",
  "Pausiert", "Nicht erreichbar"
];

export const STATUS_TONE = {
  "Neuer Lead": "info",
  "Daten unvollständig": "warning",
  "Rückfrage gesendet": "info",
  "Angebotsentwurf erstellt": "info",
  "Wartet auf Freigabe": "warning",
  "Angebot versendet": "info",
  "Angebot geöffnet": "success",
  "Nachfassen aktiv": "info",
  "Kunde hat geantwortet": "success",
  "Hot Lead": "warning",
  "Rückruf geplant": "warning",
  "Gewonnen": "success",
  "Verloren": "error",
  "Pausiert": "muted",
  "Nicht erreichbar": "muted",
};

export const TONE_CLASSES = {
  info: "bg-blue-50 text-blue-700 border-blue-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-800 border-amber-200",
  error: "bg-red-50 text-red-700 border-red-200",
  muted: "bg-slate-100 text-slate-600 border-slate-200",
};

export const PROPERTY_TYPES = ["EFH", "ZFH", "MFH", "Gewerbe"];
export const ROOF_TYPES = ["Satteldach", "Flachdach", "Pultdach", "Walmdach", "Mansarddach"];
export const ORIENTATIONS = ["Süd", "Süd-Ost", "Süd-West", "Ost-West", "Ost", "West", "Nord"];
export const YESNO = ["Ja", "Nein", "Unsicher"];

// ============= Energie-Erweiterung Phase A — Produktpfade, Prioritäten, Estimate-Status =============
export const SOLUTION_TYPES = {
  pv: { label: "Solaranlage", short: "PV", badge: "bg-amber-50 text-amber-800 border-amber-200" },
  heat_pump: { label: "Wärmepumpe", short: "WP", badge: "bg-sky-50 text-sky-700 border-sky-200" },
  pv_heat_pump: { label: "Solar + Wärmepumpe", short: "PV+WP", badge: "bg-violet-50 text-violet-700 border-violet-200" },
};
// Lesender Fallback: unbekannt/fehlend = pv (Bestandsdaten)
export const solutionTypeInfo = (v) => SOLUTION_TYPES[v] || SOLUTION_TYPES.pv;

export const IMPLEMENTATION_TIMELINES = {
  immediate: { label: "Sofort", badge: "bg-red-50 text-red-700 border-red-200" },
  under_3_months: { label: "In den nächsten 3 Monaten", badge: "bg-amber-50 text-amber-800 border-amber-200" },
  over_3_months: { label: "Später als 3 Monate", badge: "bg-blue-50 text-blue-700 border-blue-200" },
  info_only: { label: "Erstmal informieren", badge: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const LEAD_PRIORITIES = {
  urgent: { label: "Dringend", badge: "bg-red-100 text-red-800 border-red-300" },
  high: { label: "Hoch", badge: "bg-orange-50 text-orange-700 border-orange-200" },
  normal: { label: "Normal", badge: "bg-slate-100 text-slate-600 border-slate-200" },
  low: { label: "Niedrig", badge: "bg-slate-50 text-slate-500 border-slate-200" },
};
export const priorityInfo = (v) => LEAD_PRIORITIES[v] || LEAD_PRIORITIES.normal;

export const ESTIMATE_STATUS_LABELS = {
  "": "—",
  created: "Schätzung erstellt",
  sent: "Schätzung gesendet",
  opened: "Schätzung geöffnet",
};

export const formatEUR = (n) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return "—"; }
};
